/**
 *
 * @module postseasonGameTypes
 * @author Greg Babula [greg.babula@mlb.com]
 *
 */

define('Horizontal-Postseason-Scoreboard/src/scripts/core/postseasonGameTypes',['require','exports','module'],function(require, exports, module) {

    'use strict';

    return {
        wc: 'F',
        ds: 'D',
        cs: 'L',
        ws: 'W',
        tb: 'R'
    };

});

